module.exports = __webpack_public_path__ + "static/media/undraw_discount_d4bd.7dfe4b09.svg";